import axios from 'axios';
// config
import { DJANGO_API } from 'src/config-global';

// ----------------------------------------------------------------------
// await postFetcher(['courses/api/installment/fee-payment', payloadInstallment])
// 
const axiosInstance = axios.create({ baseURL: DJANGO_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------
// GET Fetcher (DEFAULT)
// ----------------------------------------------------------------------
export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------
// POST Fetcher
// ----------------------------------------------------------------------

export const postFetcher = async (args) => {
  const [url, data, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.post(url, data, { ...config });

  return res.data;
};
// ----------------------------------------------------------------------
// PUT Fetcher
// ----------------------------------------------------------------------

export const putFetcher = async (args) => {
  const [url, data, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.put(url, data, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------
// PATCH Fetcher
// ----------------------------------------------------------------------

export const patchFetcher = async (args) => {
  const [url, data, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.patch(url, data, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------
// DELETE Fetcher
// ----------------------------------------------------------------------

export const deleteFetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.delete(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
};
